const translations = {
    boundaryNameFieldLabel: 'Boundary Name'
};

export default translations;
